import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import { InputComponent } from "./InputComponent";

const EventSchedularComp = ({ qrData, setQrData, onChangeTime, isEdit }) => {
  const [selectedTimeZone, setSelectedTimeZone] = useState(
    qrData.event_time_timezone || moment.tz.guess()
  );
  const [timeFormat, setTimeFormat] = useState("24h");

  const timeZones = moment.tz.names().map((zone) => {
    const offset = moment.tz(zone).format("Z");
    return `${zone} (GMT${offset})`;
  });

  useEffect(() => {
    setQrData((prev) => ({
      ...prev,
      event_time_timezone: selectedTimeZone,
    }));
  }, [selectedTimeZone, setQrData]);

  const handleTimeFormatChange = (format) => {
    setTimeFormat(format);
  };

  const handleStartDateChange = (e) => {
    setQrData((prev) => ({
      ...prev,
      event_time_start: e.target.value,
    }));
  };

  const handleStartTimeChange = (e) => {
    setQrData((prev) => ({
      ...prev,
      scheduleTimeStart: e.target.value,
    }));
  };

  const handleEndDateChange = (e) => {
    setQrData((prev) => ({
      ...prev,
      event_time_end: e.target.value,
    }));
  };

  const handleEndTimeChange = (e) => {
    setQrData((prev) => ({
      ...prev,
      scheduleTimeEnd: e.target.value,
    }));
  };

  const handleAllDayChange = (e) => {
    setQrData((prev) => ({
      ...prev,
      event_time_all_day: e.target.checked,
    }));
  };

  const handleTimeZoneChange = (e) => {
    setSelectedTimeZone(e.target.value);
  };

  return (
    <div className="eventScheduleComp">
      <div className="top">
        <p
          className={`time-format-option ${
            timeFormat === "am/pm" ? "active" : ""
          }`}
          onClick={() => handleTimeFormatChange("am/pm")}
        >
          AM/PM
        </p>
        <p
          className={`time-format-option ${
            timeFormat === "24h" ? "active" : ""
          }`}
          onClick={() => handleTimeFormatChange("24h")}
        >
          24 Hours
        </p>
      </div>

      <div className="bottom">
        {/* START DATE & TIME */}
        <div className="input-con">
          <div className="input-wrap">
            <label>Start</label>
            <input
              type="date"
              value={qrData.event_time_start || ""}
              onChange={handleStartDateChange}
            />
          </div>
          {!isEdit && (
            <input
              type="time"
              value={qrData.scheduleTimeStart || ""}
              onChange={handleStartTimeChange}
              step={timeFormat === "am/pm" ? 60 : 1}
            />
          )}
        </div>

        {/* END DATE & TIME */}
        <div className="input-con">
          <div className="input-wrap">
            <label>End</label>
            <input
              type="date"
              value={qrData.event_time_end || ""}
              onChange={handleEndDateChange}
            />
          </div>
          {!isEdit && (
            <input
              type="time"
              value={qrData.scheduleTimeEnd || ""}
              onChange={handleEndTimeChange}
              step={timeFormat === "am/pm" ? 60 : 1}
            />
          )}
        </div>

        {/* ALL DAY & TIME ZONE */}
        <div className="timezone-con">
          <label className="label-allday">
            <input
              type="checkbox"
              checked={qrData.event_time_all_day}
              onChange={handleAllDayChange}
            />
            All day
          </label>
          <div className="timezone-main">
            <label htmlFor="timezone">Time Zone:</label>
            <select
              id="timezone"
              value={selectedTimeZone}
              onChange={handleTimeZoneChange}
            >
              {timeZones.map((zone) => (
                <option key={zone} value={zone}>
                  {zone}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* ACTION TITLE INPUT */}
        <InputComponent
          label={"Add to calendar button text"}
          placeholder={"e.g. Add to calendar"}
          name="event_time_action_title"
          value={qrData?.event_time_action_title}
          onChange={onChangeTime}
        />

        <p className="allow-guest-txt">
          Allow guests to add your event directly to their calendars.
        </p>
      </div>
    </div>
  );
};

export default EventSchedularComp;
